var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36CF8A",
    fillRule: "evenodd",
    d: "M30.807 11.574c-1.25-.909-3.001-.634-3.91.62l-8.953 12.329-4.82-4.888a2.798 2.798 0 1 0-3.987 3.93l7.139 7.239a2.798 2.798 0 0 0 4.258-.32l10.893-15c.909-1.25.63-3-.62-3.91M40 40H20C8.972 40 0 31.028 0 20S8.972 0 20 0s20 8.972 20 20z",
    clipRule: "evenodd"
  })));
});
const SvgAmCircle = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmCircle);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMC44MDY1IDExLjU3NDNDMjkuNTU2OSAxMC42NjUxIDI3LjgwNTcgMTAuOTQwMSAyNi44OTY1IDEyLjE5NDVMMTcuOTQ0MiAyNC41MjI1TDEzLjEyMzUgMTkuNjM0OEMxMi4wMzc4IDE4LjUzMzQgMTAuMjY2NCAxOC41MjEgOS4xNjUxNyAxOS42MDY2QzguMDYzNzcgMjAuNjkyMyA4LjA1MTMyIDIyLjQ2NTMgOS4xMzY5IDIzLjU2NDlMMTYuMjc1NyAzMC44MDM4QzE2LjgwMzkgMzEuMzM5NiAxNy41MjI0IDMxLjYzNzkgMTguMjY4OSAzMS42Mzc5QzE4LjMzOTMgMzEuNjM3OSAxOC40MDk2IDMxLjYzNDkgMTguNDc5OSAzMS42MzAyQzE5LjMgMzEuNTY3NyAyMC4wNTEzIDMxLjE0OSAyMC41MzQxIDMwLjQ4MzVMMzEuNDI2NyAxNS40ODQyQzMyLjMzNTggMTQuMjMzMSAzMi4wNTc4IDEyLjQ4MzQgMzAuODA2NSAxMS41NzQzVjExLjU3NDNaTTQwIDQwSDE5Ljk5OTlDOC45NzE4OCA0MCAwIDMxLjAyNzkgMCAxOS45OTk5QzAgOC45NzE4OCA4Ljk3MTg4IDAgMTkuOTk5OSAwQzMxLjAyODEgMCA0MCA4Ljk3MTg4IDQwIDE5Ljk5OTlWNDBaIiBmaWxsPSIjMzZDRjhBIi8+Cjwvc3ZnPgo=";